export default build =>
    build.query({
        tagTypes: ['allDealers'],
        keepUnusedDataFor: 1,
        query(payload) {           
            return {
                url: `/dealer/getAllDealers`,            
                method: 'GET'              
            };
           
        },
       providesTags: ['allDealers']
    })
